import { foldDigits } from '@/lib/text/fold-digits'

/**
 * The digits of a one-time code as typed or pasted (locale audit, 2026-09-26).
 *
 * Code fields used to keep `value.replace(/\D/g, '')`. `\D` means "not ASCII
 * 0-9", so every digit typed on an Arabic (٠-٩), Persian (۰-۹) or Hindi
 * (०-९) keypad was deleted and the field stayed empty. Fold those digits to
 * ASCII first, then drop whatever is left (spaces, dashes, letters).
 */
export function codeDigits(value: string): string {
  return foldDigits(value).replace(/\D/g, '')
}
